export default {"src":"/_next/static/media/figma.598f7f71.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};